<template>
  <div class="branch-container">
    <el-row>
      <el-col :span="isGeneralAdmin || hasFilter ? 12 : 24">
        <organization-breadcrumb :items="[$t('menu.branch')]" />
      </el-col>
      <el-col v-if="isGeneralAdmin || hasFilter" :span="12">
          <admin-organization-switcher/>
      </el-col>
    </el-row>
    <div class="table">
        <div class="elsa-table-layout-header">
            <div class="flex justify-center title">
                <h2>{{ $t('branch.list_branch.title') }}</h2>
            </div>
            <div class="search-wrap">
                <el-form class="search-form mr-px-16">
                    <elsa-search
                    v-model="queryString"
                    @search="searchBraches"
                    :placeholder="$t('branch.list_branch.search_branch')"
                    />
                </el-form>
                <div hidden class="create-assignment">
                    <router-link
                    :to="'/organization/' + organizationId + '/assignment-library/new'"
                    tag="button"
                    >
                    <span>
                        {{ $t('branch.list_branch.create_branch') }}
                    </span>
                    </router-link>
                </div>
            </div>
        </div>
        <table-layout
            :showTitle="false"
            :pager-counter="pageCounter"
            :pageSize="numberElementsPerPage"
            :total="tableDataCount"
            :currentChange="getBranchesPage"
            :current-page.sync="currentPage"
            :query-placeholder="$t('common.search')"
            :title="$t('menu.branch')"
            >
            <branch-table :data="branchesData" :handle-remove="remove" :handle-update="edit" />
        </table-layout>
    </div>
  </div>
</template>

<script>
import BranchTable from '@/components/branches/BranchTable'
import OrganizationBreadcrumb from '@/components/common/OrganizationBreadcrumb'
import { NUMBER_ELEMENTS_PER_PAGE, PAGE_COUNTER } from '@/constants/generic'
import { successMessage, warningMessage } from '@/utils/messages'
import { mapGetters, mapActions } from 'vuex'
import { pathOr, always } from 'ramda'
import AdminOrganizationSwitcher from "@/components/dashboard/AdminOrganizationSwitcher";
import ElsaSearch from '@/components/studysets/Search';
import TableLayout from '@/components/studysets/TableLayout';

export default {
  components: {
    BranchTable,
    OrganizationBreadcrumb,
    AdminOrganizationSwitcher,
    ElsaSearch,
    TableLayout
  },
  data() {
    return {
      currentPage: 1,
      queryString: null,
      modals: {
      },
    }
  },
  props: ['new', 'organizationId'],
  methods: {
    searchBraches(search) {
      return this.getBranches({ search })
    },
    remove(){},
    edit(){},
    
    getBranchesPage(page) {
      return this.getBranches({ page })
    },
    ...mapActions('branches', ['getBranches']),
    ...mapActions({
    })
  },
  computed: {
    branchesData() {
      return this.branches
    },
    
    pageCounter: always(PAGE_COUNTER),
    numberElementsPerPage: always(NUMBER_ELEMENTS_PER_PAGE),
    tableDataCount: pathOr(0, ['paginateBranches', 'count']),
    branches: pathOr([], ['paginateBranches', 'results']),
    ...mapGetters('branches', ['paginateBranches']),
    ...mapGetters('organization', ['currentOrganizationId']),
    ...mapGetters('organization', ['currentOrganizationType','isGeneralAdmin', 'hasChildOrg', 'hasFilter']),
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType',
      currentOrganizationId: 'organization/currentOrganizationId'
    })
  },
  async mounted() {
    try {
      this.getBranches()
    } catch {
      return
    }
  },
  watch: {
      organizationId: {
        immediate: true,
        handler(newOrganizationId) {
          if(!this.hasChildOrg) {
              this.$router.push(`/organization/${newOrganizationId}/dashboard`)
          }
        }
      }
  }
}
</script>

<style lang="scss" scoped>
.branch-container {
  width: 100%;
  
  .table {
      margin: 24px 40px;
      .elsa-table-layout-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .title {
            h2{
                font-family: SF Pro Display;
                font-style: normal;
                font-weight: bold;
                font-size: 32px;
                line-height: 48px;
            }
        }
        & > div {
          align-self: center;
        }

        label {
          font-family: SF Pro Display, sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 20px;
          line-height: 20px;
          letter-spacing: 0.25px;
          color: #121131;
        }

        .search-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          align-content: center;
        }
      }

      .el-form {
        width: auto;
        padding-bottom: 0 !important;

        .el-form-item {
          margin-bottom: 0;
        }

        &.search-form {
          margin-top: 0;
          width: 328px;
          margin-bottom: 0;
          padding-bottom: 0;
        }
      }

      ::v-deep.el-input {
        border-radius: 8px;
        height: 48px;
        align-content: center;
        align-items: center;
      }

      .el-button {
        border-radius: 8px;
      }

      .elsa-table-layout {
        margin-top: 32px;
        padding: 0;
      }

      .icon-wrap {
        display: flex;
        flex-wrap: wrap;

        .icon {
          margin: 0 5px 5px 0;
        }

        i {
          width: 28px;
          height: 28px;
        }
      }

      ::v-deep .el-table thead tr {
        background: #f9f9f9;
      }

      ::v-deep .el-table .el-table__header-wrapper .cell {
        color: #757575;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .create-assignment {
      button {
        background: #007eff;
        border-radius: 8px;
        border: none;
        color: #fff;
        padding: 12px 16px;
        font-size: 16px;
        line-height: 24px;
        max-width: 230px;
        cursor: pointer;
        font-weight: 600;
        font-family: 'SF Pro Display', sans-serif;
      }
    }
}
</style>
